// The "base CV" has a hash without any child numbers
var baseCv;
/**
 * Implementation of correlation vector
 */
var CV = /** @class */ (function () {
    function CV(value) {
        this.value = value;
        this.nextChild = 0;
    }
    /**
     * The index of the next child
     */
    CV.prototype.getNext = function () {
        return new CV("".concat(this.value, ".").concat(++this.nextChild));
    };
    return CV;
}());
export { CV };
/**
 * Gets a base correlation vector for this session
 * @returns A base correlation vector, with a value of a 22-character string
 */
export function getBaseCv() {
    if (!baseCv) {
        var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
        var hashLength = 22;
        var result = [];
        for (var i = 0; i < hashLength; i++) {
            // (security is not a concern here and secure crypto function is not available on all platform)
            // eslint-disable-next-line no-restricted-properties
            result.push(characters.charAt(Math.floor(Math.random() * characters.length)));
        }
        baseCv = new CV(result.join(''));
    }
    return baseCv;
}
//# sourceMappingURL=CorrelationVector.js.map